import React, { useState, useRef, useEffect, useCallback, Suspense } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Modal from '@components/common/Modal';
import Loader from '@components/common/Loader/newLoaderModal';
import PageLoader from '@components/common/PageLoader';
import ToggleButton from '../ToggleButton/ToggleButton';
const OptionComp = React.lazy(() => import('./optionsCompCopy'));
import { setNotification, setErrorPopUp } from '@reducers/notification';
import { employeeTips, deviceActivate } from '@reducers/utils';
import { setVisible } from '@reducers/optionsMenus';
import { employeeCashOut, drawerCashOut } from '@reducers/cashOut';
import {
  getAllChecks,
  showOpenChecks,
  setMyChecks,
} from '@reducers/storeChecks';
import { 
  removeSeat,
  setSeat,
  setPaymentCheck,
  setOfflineVoid,
} from '@reducers/orders';
import { changeJob, logout,  } from '@reducers/oauth';
import { getFormatedPhoneNumber } from '@utility/helperFunction';
import { getObjectValue } from '@utility/utills';
import EventEmitter from '@utility/eventSubscribers';
import {
  getStoreChecks,
  subscribeToStoreChecks,
  disconnect,
} from '../../../sockets/communicator';
import { APP_CONFIG } from '@constants';
import { LABEL, CUSTOM_MESSAGES } from '../../../veriables';
import { ReactComponent as Hamburger } from '@assets/images/hamburger.svg';
import cn from 'classnames';
import styles from './optionMenu.module.scss';
import style from './optionMenuCopy.module.scss';
import { TouchableDiv } from '../Touchable/index';
import OfflinePayScreen from './OfflinePayScreen';
import { checkOpen } from '@reducers/checks';
import {
  orderFinalize,
  driveSplitCheck
} from '@reducers/payment';
import OfflinePayScreenLandscape from './OfflinePayScreenLandscape';

const OptionMenus = props => {
  // Props Destructuring
  const { serverAppTheme, setIsTipOnlyEnabled, orderingPortraitOrientation} = props;
  const ref = useRef(null);
  const dropDownRef = useRef(null);

  // State Management
  const [responseData, setResponseData] = useState(null);
  const [aboutData, setAboutData] = useState(null);
  const [isChangeJob, setIsChangeJob] = useState(false);
  const [errors, setErrors] = useState('');
  const [defaultValue, setDefaultValue] = useState(props.userInfo?.jobId);
  const [isMenus, setIsMenus] = useState(false);
  const [drawerAlert, setDrawerAlert] = useState({
    isOpen: false,
    message: '',
  });
  const { drawerIpAddress, drawerPort } = props.deviceInfo;
  const eventObj = { drawerIpAddress, drawerPort };
  const optionForDropdown = Object.values(props.employeeJobHashTable).filter(
    e => e.allowEmployeeJobAssignment
  );
  const [isTipShow, setTipShow] = useState(false);
  const [isAboutShow, setAboutTipShow] = useState(false);

  const signalUserActivity = useCallback(() => {
    document.dispatchEvent(new Event('customUserActivity'));
  }, []);
  const serverAppNavigationMenu = props.deviceInfo?.deviceGroup?.serverAppNavigationMenu || {};
  const emptyDeviceGroup = props.deviceInfo?.deviceGroup === null;
  const [isOfflineScreen, setIsOfflineScreen] = useState(false);
  const INITIAL_INPUTS = {
    checkName: '',
    orderId: '',
    amount1: '',
    amount2: '',
    totalAmount: '0.00',
  };
  const [inputs, setInputs] = useState(INITIAL_INPUTS);
  const isOrderingPortrait =  false;

  const options = [
    {
      name: LABEL().ALL_CHECKS,
      key: 'allChecks',
      visible: emptyDeviceGroup || (serverAppNavigationMenu?.allChecks && props.allChecksVisible),
    },
    {
      name: LABEL().OPEN_CHECKS,
      key: 'openChecks',
      visible: !props.allChecksVisible,
    },
    {
      name: LABEL().LB_LOYALTY_BALANCE,
      key: 'loyaltyAccountBalance',
      visible: (emptyDeviceGroup ? 
    props?.auth?.loyaltyInfo?.supportsLoyalty : serverAppNavigationMenu?.loyaltyBalance &&
    props?.auth?.loyaltyInfo?.supportsLoyalty)
    },
    {
      name: LABEL().GIFT_BALANCE,
      key: 'giftBalance',
      visible: emptyDeviceGroup ? (props?.auth?.loyaltyInfo?.supportsGiftCardPayment ||
        props?.auth?.loyaltyInfo?.supportsGiftCardSale) : (serverAppNavigationMenu?.giftCardBalance &&
        (props?.auth?.loyaltyInfo?.supportsGiftCardPayment ||
        props?.auth?.loyaltyInfo?.supportsGiftCardSale)),
    },
    {
      name: LABEL().GAME_CARD_BALANCE ,
      key: 'gameCardBalance',
      visible: props?.auth?.gamingSystemConfig !== null && serverAppNavigationMenu?.gameCardBalance,
    },
    {
      name: props?.auth?.thirdPartyAppName,
      key: 'lauchExternalApp',
      visible: props?.auth?.thirdPartyAppName && props?.auth?.thirdPartyAppUrl,
    },
    {
      name: LABEL().HAMBURGER_OFFLINE_PAYMENT,
      key: 'offlinePayment',
      visible: serverAppNavigationMenu?.offlinePayment,
    },
    {
      name: LABEL().TIP_ONLY,
      key: 'tipOnly',
      visible: serverAppNavigationMenu?.tipOnly,
    },
  ];

  // React Hooks

  const handleClickOutside = useCallback(
    event => {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsMenus(false);
        setIsChangeJob(false);
        setTipShow(false);
        signalUserActivity();
      }
    },
    [signalUserActivity]
  );

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [handleClickOutside]);

  useEffect(() => {
    if (isMenus) {
      handleMytips();
      handleAbout();
    }
  }, [isMenus]);

  const handleMytips = data => {
    setResponseData({ isOpen: true, data });
  };

  const splitFinalise = useCallback(
    ({ data = {} }) => {
      const dataToSendToAdd = {
        deviceId: props?.deviceInfo?.deviceId,
        employeeId: props?.userInfo?.id,
        checkHeaderId: data?.id,
        storeId: data?.storeId,
        unpaidAmount: data?.unpaidAmount,
        totalAmount: data?.totalAmount,
        paidAmount: data?.paidAmount,
        splitType: 0,
      };
      props
        .driveSplitCheck(dataToSendToAdd) // 3. finalizeSplit api
        .then(res => {
          const syncedCheck = res?.check || data;
          let updatedData = {
            ...syncedCheck,
            control: res?.control,
            checkHeaderId: res?.checkHeaderId,
            storeId: res?.storeId,
            giftCard: res?.giftCard,
            offer: res?.offer,
            paymentCheck: res?.paymentCheck,
            paymentChecks: res?.paymentChecks,
            availableLoyaltyOffers: res?.availableLoyaltyOffers,
            check: res?.check,
          };
          props.setSeat(updatedData);
          props.setPaymentCheck(updatedData);
          // navigate to tip screen
          props.navigate(
            `${APP_CONFIG.BASE_URL}/receipt/${res?.paymentCheck?.id
            }?ticketSplitTypeId=1&splitValue=1&screenType=4&type=payType`,
            { replace: true }
          );
        })
        .catch(err => {
          props.setErrorPopUp({
            res: err.message,
          });
        });
    },
    [
      props.deviceInfo,
      props.userInfo,
      props.driveSplitCheck,
      props.setSeat,
      props.setPaymentCheck,
      props.navigate,
      props.setErrorPopUp,
    ]
  );

  const handleOfflinePayment = () => {
    const dataToSend = {
      deviceId: props.deviceInfo?.deviceId,
      employeeId: Number(props.userInfo?.id),
      storeId: props.deviceInfo?.storeId,
      stationId: null,
      employeeCard: props.userInfo?.employeeCard,
      stationGroupId: null,
      isTab: true,
      phoneNumber: null,
      pickupTime: null,
      guestName: null,
      guestCount: 1,
      sourceType: 14,
      delivery: false,
      speedOrder: false,
      name: inputs?.checkName,
      number: inputs?.orderId,
      subtotalAmount: +inputs?.amount1,
      taxAmount: +inputs?.amount2,
      totalAmount: +inputs?.totalAmount
    };
    props
      .checkOpen(dataToSend) // 1. open api
      .then((res) => {
        const dataToSend = {
          deviceId: props?.deviceInfo?.deviceId,
          employeeId: props?.userInfo?.id,
          storeId: props?.deviceInfo?.storeId,
          items: res?.items,
          checkHeaderId: res?.id,
          name: res?.name,
          number: res?.number,
          subtotalAmount: res?.subtotalAmount || 0,
          taxAmount: res?.taxAmount || 0,
          totalAmount: res?.totalAmount || 0
        };
        props
          .orderFinalize(dataToSend) // 2. finalize api
          .then(resData => {
            splitFinalise({ data: resData }); // 3. finalizeSplit function
          })
          .catch(err => {
            props.setErrorPopUp({
              res: err.message,
            });
          });
      })
      .catch(err => {
        props.setErrorPopUp({
          res: err.message,
        });
      });
  }

  const handleOfflineScreen = () => {
    setIsOfflineScreen(true);
    setIsMenus(false);
    setIsTipOnlyEnabled(false);
  }

  const handleChecks = () => {
    if (props?.allChecksVisible) {
      props.getAllChecks(props.deviceInfo.storeId, true).then(() => {
        props.removeSeat();
        props.setVisible();
        setIsMenus(false);
      });
    } else {
      props.showOpenChecks().then(() => {
        props.removeSeat();
        props.setVisible();
        setIsMenus(false);
      });
    }
  };
  const handleToggle = () => {
    props.setMyChecks();
  };

  const handleAbout = data => {
    const dataTosend = {
      store: props.auth.name,
      device: props.deviceInfo.deviceName,
      appVersion: props.nativeAppVersion,
      webVersion: APP_CONFIG.VERSION,
      environment: props.environment,
      forSupport: getObjectValue(
        () => getFormatedPhoneNumber(props.auth.supportPhoneNumber),
        ''
      ),
      deviceGroup: props.deviceInfo?.deviceGroup
        ? props.deviceInfo?.deviceGroup?.name
        : '',
    };
    setAboutData({ isOpen: true, data, val: dataTosend });
  };

  const handleSyncChecks = () => {
    subscribeToStoreChecks(props.auth.id);
    getStoreChecks(props.auth.id);
    setIsMenus(false);
  };

  const handleChangeJob = () => {
    setIsChangeJob(!isChangeJob);
    setTipShow(false);
    setDefaultValue(props.userInfo.jobId);
  };

  const onSubmit = data => {
    props
      .changeJob({
        jobId: data || null,
        employeeId: props.userInfo.id,
        storeId: props.userInfo.storeId,
      })
      .then(() => {
        setIsChangeJob(false);
        const dataToSend = {
          latitude: '92',
          longitude: '92',
          deviceId: props.deviceInfo.deviceId,
          employeeId: props.userInfo.externalId,
          employeeCard: props.userInfo.employeeCard,
        };
        props.logout(dataToSend);
        props.navigate('/checkIn', { replace: true });
      })
      .catch(e => {
        setIsChangeJob(false);
        props.setErrorPopUp({
          res: err.message,
        });
      });
  };

  const handleChange = id => {
    onSubmit(id);
  };

  const jobName = () => {
    let name;
    if (props.userInfo?.jobName) {
      name = props.userInfo?.jobName;
    } else if (
      !props.userInfo?.jobName &&
      props.userInfo?.jobId &&
      props.employeeJobHashTable[props.userInfo.jobId]
    ) {
      name = props.employeeJobHashTable[props.userInfo.jobId]?.name;
    }
    return name;
  };

  const lauchExternalApp = () => {
    const url = props.auth.thirdPartyAppUrl;
    const constructUrl = url
      .replace('{brandId}', props.auth.brandId)
      .replace('{storeId}', props.deviceInfo.storeId)
      .replace('{storeExternalId}', props.auth.id)
      .replace('{deviceId}', props.deviceInfo.deviceId)
      .replace('{storeNumber}', props.auth.storeNumber)
      .replace('{employeeId}', props.deviceInfo.employeeId || props.userInfo.id)
      .replace('{checkId}', 0)
      .replace('{checkNumber}', 0)
      .replace('{tableNumber}', 0);

    if (window.ReactNativeWebView) {
      EventEmitter.lauchExternalApp({
        url: constructUrl,
      });
    } else {
      window.location = constructUrl;
    }
    setIsMenus(false);
    setResponseData(null);
    disconnect();
    window.sessionStorage.clear();
  };

  const handleGiftCardBalance = () => {
    window.sessionStorage.setItem('giftCard_type', 'balance')
    props.navigate(`${APP_CONFIG.BASE_URL}/giftcard/${123}?type=balance`, {
      replace: true,
    });
  };

  const handleGameCardBalance = () => {
    props.navigate(`${APP_CONFIG.BASE_URL}/gamecard/${123}?type=balance`, {
      replace: true,
    })
  };

  const handleLoyaltyAccountBalance = () => {
    props.navigate(`${APP_CONFIG.BASE_URL}/loyalty-balance`, { replace: true });
  };

  const menusClick = data => {
    switch (data.key) {
      case 'myTips':
        handleMytips(data);
        break;
      // case 'pairWatch': setIsPairWatch(true); break;
      case 'about':
        handleAbout(data);
        break;
      case 'allChecks':
        handleChecks();
        break;
      case 'openChecks':
        handleChecks();
        break;
      case 'syncChecks':
        handleSyncChecks();
        break;
      case 'changeJobType':
        handleChangeJob();
        break;
      case 'lauchExternalApp':
        lauchExternalApp();
        break;
      case 'giftBalance':
        handleGiftCardBalance();
        break;
      case 'gameCardBalance':
        handleGameCardBalance();
        break;
      case 'loyaltyAccountBalance':
        handleLoyaltyAccountBalance();
        break;
      case 'offlinePayment':
        handleOfflineScreen();
        break;
      case 'tipOnly':
        props.handleTipOnly();
        setIsMenus(false);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    return () => {
      clearInterval(intervalId.current);
      clearTimeout(timeoutId.current);
    };
  }, []);

  const intervalId = useRef(null);
  const successDrawerOpen = () => {
    intervalId.current = setInterval(() => {
      EventEmitter.drawerStatus(eventObj, res => {
        if ([9, 1].includes(res.status)) {
          clearInterval(intervalId.current);
        }
      });
    }, 1000);
  };

  const timeoutId = useRef(null);
  let retryCount = 0;
  const handleDrawerStatusCheck = () => {
    retryCount += 1;
    EventEmitter.drawerStatus(eventObj, res => {
      timeoutId.current = setTimeout(() => {
        clearTimeout(timeoutId.current);
        if ([1].includes(res.status) && retryCount <= 3) {
          return handleDrawerStatusCheck();
        }
        if (res.status === 0) {
          props.navigate('/cashOut/bills', {
            replace: true,
            state: { drawerOpen: true },
          });
          return successDrawerOpen();
        }
        return setDrawerAlert({
          isOpen: true,
          message: `${CUSTOM_MESSAGES().DRAWER_CASHOUT_FAIL}`,
        });
      }, 1000);
    });
  };

  const handleCashOut = () => {
    const dataToSend = {
      storeId: props.userInfo?.storeId,
      employeeId: props.userInfo.id,
      deviceId: props.deviceInfo.deviceId,
    };
    if (props.userInfo.supportsCashDrawer && props.deviceInfo.storeDrawerId) {
      props
        .employeeCashOut({ ...dataToSend })
        .then(() => {
          if (window.ReactNativeWebView) {
            EventEmitter.drawerOpen(eventObj);
            handleDrawerStatusCheck();
          }
        })
        .catch(err => {
          setDrawerAlert({ isOpen: true, message: err.message });
        });
    } else {
      props
        .employeeCashOut(dataToSend)
        .then(res => {
          if (res.jobType !== 4) {
            props.navigate('/report/server/cashOut', {
              state: { response: res },
              replace: true,
            });
          } else if (res.jobType === 4 && !props.userInfo.supportsCashDrawer) {
            setDrawerAlert({
              isOpen: true,
              message: CUSTOM_MESSAGES().EMPLOYEE_DRAWER_FAIL,
            });
          } else {
            if (window.ReactNativeWebView) {
              EventEmitter.drawerOpen(eventObj);
              handleDrawerStatusCheck();
            }
          }
        })
        .catch(err => {
          props.setErrorPopUp({
            res: err.message,
            noErrorTxt: true,
          });
        });
    }
  };
  const giftCardValidation = i => {
    return i == 3
      ? props.auth?.loyaltyInfo?.giftCardMethods == null
        ? true
        : props.auth?.loyaltyInfo?.giftCardMethods.includes('')
      : false;
  };

  const handleBack = () => {
    setResponseData(null);
  };

  const handleMenuOpen = e => {
    e.preventDefault();
    signalUserActivity();
    setIsMenus(true);
    setAboutTipShow(false);
    setTipShow(false);
    setIsChangeJob(false);
  };

  const getHeightClass = e => {
    const checkVisibility =
      Number(
        props.employeeJobHashTable?.[props.userInfo?.jobId]?.checkVisibility
      ) === 1;

    if (checkVisibility) {
      return e.name === LABEL().GIFT_BALANCE
        ? 'h-10'
        : e.name === LABEL().LOYALTY_ACCOUNT_BALANCE
        ? 'text-center'
        : 'h-25';
    }

    return e.name === LABEL().LOYALTY_ACCOUNT_BALANCE
      ? 'h-15 text-center'
      : 'h-10';
  };
  const fullName = `${props.userInfo?.firstName ?? ''} ${props.userInfo?.lastName ?? ''}`;
  const displayName = fullName.length > 30 ? `${fullName.slice(0, 30)}...` : fullName;

  // HTML CSS CODE

  return (
    <div className="position-relative">
      {props.loading && <PageLoader />}
      {props.loading && <Loader />}
      {!isMenus && (
        <TouchableDiv className={cn(orderingPortraitOrientation ? 'mr-2' : "mr-3")} onClick={e => handleMenuOpen(e)}>
          <Hamburger
            fill={serverAppTheme?.secondary_iconcolor}
            alt="appsIcon"
          />
        </TouchableDiv>
      )}
      {isMenus && (
        <div
          ref={ref}
          className={cn(
            styles.optionCard,
            'position-fixed px-3 py-3 h-100',
            orderingPortraitOrientation ? 'col-6' : 'col-4'
          )}
          style={{
            background: serverAppTheme?.card_bg,
            border: serverAppTheme?.card_border,
            color: serverAppTheme?.primary_text,
            zIndex: '',
          }}
        >
          <div className={cn('row pb-2', orderingPortraitOrientation ? displayName.length > 17 ? 'h-10' : 'h-8' : 'h-10')}>
            <TouchableDiv
              role="presentation"
              className="col-2"
              onClick={e => {
                e.preventDefault();
                setIsMenus(false);
                setAboutTipShow(false);
                setTipShow(false);
                setIsChangeJob(false);
                signalUserActivity();
              }}
            >
              <Hamburger
                fill={serverAppTheme?.secondary_iconcolor}
                alt="appsIcon"
              />
            </TouchableDiv>
            <div className="col-10 align-items-center px-0 mx-0 pl-2">
              <div className={cn('col-12 p-0 m-0 text-left', orderingPortraitOrientation ? 'fs_20' : 'fs_16')}>
                 {displayName}
              </div>
              <div className={cn('col-12 p-0 m-0 text-left', orderingPortraitOrientation ? 'fs_16' : 'fs_12')}>
                {jobName()}
              </div>
            </div>
          </div>

          {/* hamburger buttons */}
          <div className="h-90 overflowY">
            {responseData &&
              options.map((e, index) => {
                return (
                  e.visible &&
                  e.key != 'pairWatch' && (
                    <div
                      className={cn(
                        ' align-items-center my-2',
                        getHeightClass(e)
                      )}
                    >
                      <TouchableDiv
                        key={e.name}
                        role="presentation"
                        onClick={event => {
                          menusClick(e);
                          event.preventDefault();
                          signalUserActivity();
                        }}
                        className={cn(
                          'd-flex fs_20 fw-500 justify-content-center align-items-center border-0 rounded w-100 text-center',
                          e.name !== LABEL().LOYALTY_ACCOUNT_BALANCE && 'pt-1',
                          Number(
                            props.employeeJobHashTable[props?.userInfo?.jobId]
                              ?.checkVisibility
                          ) === 1
                            ? e.name === LABEL().GIFT_BALANCE
                              ? ''
                              : 'h-50'
                            : ''
                        )}
                        style={{
                          background:
                            e.name === LABEL().GIFT_BALANCE
                              ? giftCardValidation(index)
                                ? serverAppTheme?.secondaryBtnDisabled
                                : serverAppTheme?.secondaryBtn
                              : serverAppTheme?.secondaryBtn,
                          color:
                            e.name === LABEL().GIFT_BALANCE
                              ? giftCardValidation(index)
                                ? serverAppTheme?.btn_font_color_disabled
                                : serverAppTheme?.btn_font_color
                              : serverAppTheme?.btn_font_color,
                          cursor:
                            e.name === LABEL().GIFT_BALANCE &&
                            giftCardValidation(index) &&
                            'notAllowed',
                          pointerEvents:
                            e.name === LABEL().GIFT_BALANCE &&
                            giftCardValidation(index) &&
                            'none',
                            height: orderingPortraitOrientation ? '68px' : '44px',
                        }}
                        rippleEffect={true}
                      >
                        {e.name === 'Loyalty Account Balance' ? (
                          <div className={cn("px-2", orderingPortraitOrientation ? 'fs_24' : 'fs_20')}>{e.name}</div>
                        ) : (
                          <div className={cn(orderingPortraitOrientation ? 'fs_24' : 'fs_20')}>{e.name}</div>
                        )}
                      </TouchableDiv>

                      {(index === 0 || index === 1) &&
                        Number(
                          props.employeeJobHashTable[props?.userInfo?.jobId]
                            ?.checkVisibility
                        ) === 1 && (
                          <div className="d-flex align-items-center justify-content-center h-50">
                            <div className="text-center fw-600 fs-16 col-5 px-0">
                              {LABEL().TOGGLE_TEAM_CHECKS}
                            </div>
                            <div className="col-3 px-0">
                              <ToggleButton
                                isOn={props.isMyCheck}
                                handleToggle={handleToggle}
                                style={{}}
                              />
                            </div>
                            <div className="text-center fw-600 col-4 px-0 fs-16">
                              {LABEL().TOGGLE_MY_CHECKS}
                            </div>
                          </div>
                        )}
                    </div>
                  )
                );
              })}

            <Suspense fallback={<Loader />}>
              {responseData?.isOpen && (
                <div className="col-12 p-0 text-left">
                  <OptionComp
                    responseData={responseData}
                    // submitPairWatch={submitPairWatch}
                    handleChangeJob={handleChangeJob}
                    handleBack={handleBack}
                    handleCashOut={handleCashOut}
                    dropDownRef={dropDownRef}
                    setDefaultValue={setDefaultValue}
                    setErrors={setErrors}
                    isChangeJob={isChangeJob}
                    setIsChangeJob={setIsChangeJob}
                    optionForDropdown={optionForDropdown}
                    handleChange={handleChange}
                    defaultValue={defaultValue}
                    errors={errors}
                    aboutData={aboutData}
                    serverAppTheme={serverAppTheme}
                    isAboutShow={isAboutShow}
                    setAboutTipShow={setAboutTipShow}
                    isTipShow={isTipShow}
                    setTipShow={setTipShow}
                    serverAppNavigationMenu={serverAppNavigationMenu}
                    emptyDeviceGroup={emptyDeviceGroup}
                    orderingPortraitOrientation={orderingPortraitOrientation}
                    {...props}
                  />
                </div>
              )}
            </Suspense>
          </div>
        </div>
      )}

      {drawerAlert?.isOpen && (
        <Modal
          isOpen={drawerAlert?.isOpen}
          isModalCenter
          style={{
            backgroundColor: '#2F2F2F',
            borderRadius: '16px',
            border: serverAppTheme?.popupBorder,
            boxShadow: serverAppTheme?.popUp_box_shadow,
          }}
          noBackground
          customClass2={cn('w-100 h-100 p-3')}
        >
          <div
            className={cn('w-100 fs_18 row mx-0 p-3')}
            style={{
              backgroundColor: serverAppTheme?.popUp_bg,
              color: serverAppTheme?.primary_text,
              zIndex: '100',
              cursor: 'pointer',
              backgroundClip: 'padding-box',
              height: '100%',
              borderRadius: '16px',
            }}
          >
            <div className="text-center py-2 w-100">{drawerAlert?.message}</div>
            <TouchableDiv
              role="presentation"
              onClick={() => {
                setDrawerAlert({ isOpen: false, message: '' });
              }}
              className="col-12 align-items-center text-center p-2"
            >
              <button
                className={cn(
                  'w-40 btn-ripple btn35 rounded',
                  style.secondary_btn
                )}
              >
                {LABEL().CLOSE}
              </button>
            </TouchableDiv>
          </div>
        </Modal>
      )}
      {
        isOfflineScreen && (
          orderingPortraitOrientation ? (
            <OfflinePayScreen
              isOfflineScreen={isOfflineScreen}
              setIsOfflineScreen={setIsOfflineScreen}
              serverAppTheme={serverAppTheme}
              setErrorPopUp={props?.setErrorPopUp}
              handleOfflinePayment={handleOfflinePayment}
              inputs={inputs}
              setInputs={setInputs}
              setOfflineVoid={props?.setOfflineVoid}
              INITIAL_INPUTS={INITIAL_INPUTS}
            />
          ) : (
            <OfflinePayScreenLandscape
              isOfflineScreen={isOfflineScreen}
              setIsOfflineScreen={setIsOfflineScreen}
              serverAppTheme={serverAppTheme}
              setErrorPopUp={props?.setErrorPopUp}
              handleOfflinePayment={handleOfflinePayment}
              inputs={inputs}
              setInputs={setInputs}
              setOfflineVoid={props?.setOfflineVoid}
              INITIAL_INPUTS={INITIAL_INPUTS}
            />
          )
        )
      }
    </div>
  );
};

// Redux Part
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      employeeTips,
      deviceActivate,
      setNotification,
      setVisible,
      setMyChecks,
      changeJob,
      logout,
      employeeCashOut,
      drawerCashOut,
      getAllChecks,
      showOpenChecks,
      setErrorPopUp,
      removeSeat,
      checkOpen,
      orderFinalize,
      driveSplitCheck,
      setPaymentCheck,
      setSeat,
      setOfflineVoid,
    },
    dispatch
  );

const mapStateToProps = state => ({
  loading: state.utils.loading || state.oauth.loading || state.cashOut.loading,
  userInfo: state.oauth.loggedInUserData,
  auth: state.oauth.authInfo,
  deviceInfo: state.oauth.deviceInformation,
  nativeAppVersion: state.oauth.nativeAppVersion,
  environment: state.oauth.environment,
  allChecksVisible: state.optionsMenus.allChecksVisible,
  employeeJobHashTable: state.oauth.employeeJobHashTable,
  isMyCheck: state.storeChecks.isOn,
  orderingPortraitOrientation: state.orders.orderingPortraitOrientation
  // isOfflineVoid: state.orders.isOfflineVoid,
});

const MemoisedOptionMenus = React.memo(OptionMenus);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MemoisedOptionMenus);
